import { IPendingReview, IPendingReviewAPIResponse, IPendingReviewList } from './Types';

const toPendingReviewList = (response: IPendingReviewAPIResponse): IPendingReviewList => {
  return {
    data: response.response?.map((it) => {
      const adjustment = it.adjustments.find(({ status }) => status === 'none');

      const hasAdjustBreakTime = adjustment && it.shift.break_time !== adjustment?.break_time;

      const hasAdjustShiftTime =
        adjustment &&
        (it.shift.local_end_time !== adjustment?.local_end_time ||
          it.shift.local_start_time !== adjustment.local_start_time);

      return {
        adjustment: adjustment
          ? {
              author: adjustment.author,
              breakTime: adjustment.break_time,
              date: adjustment.date,
              localDate: adjustment.local_date,
              localEndTime: adjustment.local_end_time,
              localStartTime: adjustment.local_start_time,
              status: adjustment.status,
            }
          : undefined,
        hasAdjustment: adjustment !== undefined,
        hasAdjustBreakTime,
        hasAdjustShiftTime,
        id: it.id,
        offerOwner: {
          id: it.offer_owner._id,
          officeName: it.offer_owner.office,
        },
        profession: it.profession,
        professional: {
          id: it.professional._id,
          fullName: it.professional.full_name,
          image: it.professional.image,
        },
        shift: {
          breakTime: it.shift.break_time,
          localDate: it.shift.local_date,
          localEndTime: it.shift.local_end_time,
          localStartTime: it.shift.local_start_time,
        },
      } as IPendingReview;
    }),
    limit: response.limit,
    page: response.page,
    total: response.total,
  };
};

export const shiftReviewAdapter = {
  toPendingReviewList,
};
